import { compact } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { List } from 'dashboard/models/list';
import { ListItem, ListItemStatus } from 'dashboard/models/list-item';
import { User } from 'dashboard/models/user';
import { ListActions, ListActionType, ListFilterParams } from 'dashboard/redux/actions/list';

export interface ListState extends TableState<ListFilterParams> {
  list: List | undefined;
  listItems: ListItem[];
  users: User[];
}

const initialState: ListState = {
  list: undefined,
  listItems: [],
  users: [],
  filters: {
    status: [ListItemStatus.Pending, ListItemStatus.Active],
  },
  sortParams: {
    sort: 'created_at',
    shouldSortDescending: true,
  },
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (state: ListState = initialState, action: ListActions) => {
  switch (action.type) {
    case ListActionType.ClearList: {
      return initialState;
    }

    case ListActionType.SaveList: {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case ListActionType.SaveListDetails: {
      return {
        ...state,
        listItems: action.payload.listItems,
        users: action.payload.users,
      };
    }

    case ListActionType.SaveListAndListDetails: {
      return {
        ...state,
        list: action.payload.list,
        listItems: action.payload.listItems,
        // creators can be null if the list item was defined via API
        users: compact(action.payload.users),
        paginationParams: action.payload.paginationParams,
      };
    }

    case ListActionType.SaveListFilterParams: {
      return {
        ...state,
        filters: {
          ...action.payload.filterParams,
        },
      };
    }

    case ListActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case ListActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case ListActionType.SetSortParams: {
      return {
        ...state,
        sortParams: action.payload.sortParams,
      };
    }

    default:
      return state;
  }
};
